import React from 'react';
import { BillingDetails } from '@css-xp/base';
import { FormData } from '../create-transaction-account-sidebar';
import { CommerceAddress } from '@css-xp/graphtypes';
import { LoadingButton } from '@atlaskit/button';
import ChangePricingEligibility from '../../component/update-pricing-eligibility';

interface Props {
  setFieldValue: () => void;
  newShipToAddress: CommerceAddress;
  billToAddress: CommerceAddress;
  isChecked: boolean;
  getValues: () => void;
  onSameAsBillTo: (isCheckboxEnabled: boolean, billingData: FormData) => void;
  pricingEligibility?: string | null;
  dirty?: boolean | false;
  canSelectPricing?: boolean | false;
  onSubmitBillTo: (values: any) => void;
  isSubmittingBillTo?: boolean | false;
}

export const BillingAddressComponent = ({
  setFieldValue,
  billToAddress,
  newShipToAddress,
  isChecked,
  getValues,
  pricingEligibility,
  dirty,
  canSelectPricing,
  onSubmitBillTo,
  isSubmittingBillTo,
}: Props) => {
  return (
    <div className="create-txa-container">
      <div className="billing-section">
        <h2>Add a billing address</h2>
        <BillingDetails
          billToAddress={billToAddress}
          shipToAddress={newShipToAddress}
          isEditable={true}
          setFieldValue={setFieldValue}
          isChecked={isChecked}
          isShipToAddressViewable={false}
          hideAddressNameLabel={true}
        />
      </div>
      <div className="billing-section-submit">
        <LoadingButton
          testId="submit-billto"
          isLoading={isSubmittingBillTo}
          onClick={() => onSubmitBillTo(getValues())}
          isDisabled={!dirty}
          appearance="primary"
        >
          Save billing address
        </LoadingButton>
      </div>
      <div className="pricing-section">
        <ChangePricingEligibility
          disabled={!canSelectPricing}
          pricingEligibility={pricingEligibility}
          title="Choose pricing eligibility"
        />
      </div>
    </div>
  );
};
